import { useEffect, useState } from 'react'
import { apiClient, ApiError } from '../lib/api'
import { useAudioBibleStore } from '../stores/audioBibleStore'
import { getBookById } from '../lib/bibleBooks'

interface ResumePayload {
  book_id: string
  chapter: number
  verse: number
  position_sec: number
  translation: string
  voice_id: string
}

function formatSec(sec: number): string {
  const m = Math.floor(sec / 60)
  const s = Math.floor(sec % 60)
  return `${m}:${String(s).padStart(2, '0')}`
}

export function ResumeChip() {
  const [resume, setResume] = useState<ResumePayload | null>(null)
  const play = useAudioBibleStore((s) => s.play)

  useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const data = await apiClient.get<ResumePayload>('bible/audio/resume/')
        if (mounted) setResume(data)
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          // No resume saved — normal
        }
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  if (!resume) return null

  const bookName = getBookById(resume.book_id)?.name ?? resume.book_id

  const onResume = () => {
    void play(resume.book_id, resume.chapter, resume.translation, {
      voiceId: resume.voice_id,
      startVerse: resume.verse,
    })
  }

  return (
    <button
      type="button"
      onClick={onResume}
      className="w-full flex items-center gap-3 rounded-lg border border-accent/40 bg-accent/10 px-3 py-2.5 mb-4"
    >
      <span className="w-6 h-6 rounded-full bg-accent text-surface flex items-center justify-center text-xs">
        ▶
      </span>
      <div className="flex-1 text-left min-w-0">
        <div className="text-text-primary text-sm">
          Resume: <span className="text-accent font-semibold">{bookName} {resume.chapter}:{resume.verse}</span>
        </div>
        <div className="text-text-muted text-xs">{formatSec(resume.position_sec)} into chapter · {resume.translation}</div>
      </div>
      <span className="text-text-muted text-sm">→</span>
    </button>
  )
}
